/**
 * src/admin-ui/src/pages/Billing.styles.ts
 *
 * Billing page styles: centered balance state inside the full-bleed
 * viewport of the full-screen page pattern.
 */

import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const BalanceState = styled(Box)(({ theme }) => ({
  minHeight: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.spacing(1),
  padding: theme.spacing(2),
}));
